export const useCategoryBlockExercises = (category: CategorySchema) => {
  const { categoryLockState, currentContent, isParentChildPage } =
    inject(INJECT_CATEGORY_PAGE);

  const route = useRoute();

  const exercisesIds = computed(() => {
    if (!category.exercises) return [];
    return category.exercises.map((exercise) => exercise.id);
  });

  const progressionExercises = inject(INJECT_PROGRESSION_EXERCISES);

  const { summaryExercisesProgressionMap, totalScore, isCompleted } =
    useExercisesSummaryProgressions(progressionExercises, exercisesIds.value);

  const nbItemsCompleted = computed(() => {
    let count = 0;
    if (summaryExercisesProgressionMap.value) {
      count = Object.entries(summaryExercisesProgressionMap.value).reduce(
        (acc, [key, { status }]) => (acc = status === 'done' ? acc + 1 : acc),
        0
      );
    }
    return count;
  });

  const strScore = computed(() => {
    const strValue = getScoreOn20(totalScore.value);
    return `${strValue}/20`;
  });

  const exercisesScores = computed(() => {
    return exercisesIds.value.map((id) => {
      return summaryExercisesProgressionMap.value &&
        summaryExercisesProgressionMap.value[id]
        ? summaryExercisesProgressionMap.value[id].score
        : 0;
    });
  });

  const exercisesDone = computed(() => {
    return exercisesIds.value.map((id) => {
      return summaryExercisesProgressionMap.value &&
        summaryExercisesProgressionMap.value[id]
        ? summaryExercisesProgressionMap.value[id].status === 'done'
        : false;
    });
  });

  const exercisesOnGoing = computed(() => {
    return exercisesIds.value.map((id) => {
      return summaryExercisesProgressionMap.value &&
        summaryExercisesProgressionMap.value[id]
        ? summaryExercisesProgressionMap.value[id].status === 'onGoing'
        : false;
    });
  });

  const exercisesNotStarted = computed(() => {
    return exercisesIds.value.map((id, index) => {
      return (
        exercisesOnGoing.value[index] === false &&
        exercisesDone.value[index] === false
      );
    });
  });

  const lastExerciseIndexDone = computed(() => {
    let index = 0;
    exercisesIds.value.forEach((id, _index) => {
      if (
        summaryExercisesProgressionMap.value &&
        summaryExercisesProgressionMap.value[id]
      ) {
        if (summaryExercisesProgressionMap.value[id].status === 'done') {
          index = _index + 1;
        } else {
          index = _index;
        }
      }
    });
    return index;
  });

  const focusedIndex = computed(() => {
    const firstExercisesOnGoingIndex = exercisesOnGoing.value.findIndex(
      (item) => item === true
    );
    const firsteExercisesNotStarted = exercisesNotStarted.value.findIndex(
      (item) => item === true
    );
    if (firstExercisesOnGoingIndex === -1 && firsteExercisesNotStarted === -1)
      return -1;
    if (firstExercisesOnGoingIndex === -1) return firsteExercisesNotStarted;
    if (firsteExercisesNotStarted === -1) return firstExercisesOnGoingIndex;
    return firstExercisesOnGoingIndex < firsteExercisesNotStarted
      ? firstExercisesOnGoingIndex
      : firsteExercisesNotStarted;
  });

  const exercises = computed(() => {
    const items = [];
    let basePath;
    if (route.params.eval) {
      basePath = `/${Sections.ChildForYou}/eval/${route.params.eval}/${category.slug}/exercise`;
    } else if (route.params.section) {
      basePath = `/${route.params.section}/${currentContent.value.slug}/${category.slug}/exercise`;
    }

    const length = category?.exercises?.length || 0;

    if (length === 0) return [];

    category.exercises.forEach((exercise, index) => {
      items.push({
        id: exercise.id,
        index,
        text: exercise.title,
        slug: exercise.slug,
        score: exercisesScores.value[index],
        onGoing: exercisesOnGoing.value[index],
        completed: exercisesDone.value[index],
        previousCompleted: index > 0 ? exercisesDone.value[index - 1] : true,
        nextCompleted:
          index < length - 1 ? exercisesDone.value[index + 1] : false,
        path: `${basePath}/${exercise.slug}`,
        lockedContent: exercise.lockedContent,
      });
    });
    return items;
  });

  return {
    isCompleted,
    isParentChildPage,
    isTypeExerciseLocked: categoryLockState.value.isTypeExerciseLocked,
    nbItemsCompleted,
    strScore,
    exercisesScores,
    exercisesDone,
    lastExerciseIndexDone,
    exercises,
    focusedIndex,
  };
};
